export default "__VITE_ASSET__beb95e40__"